var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "mdfeTranslate.PackageNumber"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.max2000Line"
                                      ),
                                      type: "textarea",
                                      rows: 5,
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.packageNumbers,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "packageNumbers",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.packageNumbers",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "receivablePayable.TicketNumber"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.max2000Line"
                                      ),
                                      type: "textarea",
                                      rows: 5,
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.waybillNumbers,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "waybillNumbers",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.waybillNumbers",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.UpdateTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "picker-options": _vm.pickerOptions,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                            },
                            model: {
                              value: _vm.queryForm.params.invoiceIssueTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "invoiceIssueTime",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.invoiceIssueTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.businessType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "businessType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.businessType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "0",
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.expressDelivery"
                                  ),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("collectionCenter.lanshou"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.client") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                remote: "",
                                "reserve-keyword": "",
                                "collapse-tags": "",
                              },
                              on: {
                                "visible-change": function ($event) {
                                  return _vm.getCustomerPage()
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.customerIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerIds",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    (item.username
                                      ? "（" + item.username + "）"
                                      : ""),
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.ReasonForFailure"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.failedReason,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "failedReason",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.failedReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-search",
                              size: "mini",
                            },
                            on: { click: _vm.getTable },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh", size: "mini" },
                            on: { click: _vm.onReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:cte-rebuildCreate",
                      expression: "'btn:invoiceCenter:cte-rebuildCreate'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.bulkRebuildCreate()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Rebuild")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:cte-bulkExport",
                      expression: "'btn:invoiceCenter:cte-bulkExport'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.bulkExport()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableListRef",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-key": "id",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "waybillNumber",
                  label: _vm.$t("receivablePayable.TicketNumber"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "packageNumber",
                  label: _vm.$t("mdfeTranslate.PackageNumber"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessType",
                  label: _vm.$t("collectionCenter.businessT"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.businessType === 0
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("collectionCenter.expressDelivery")
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("collectionCenter.lanshou"))
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "msgBody",
                  label: _vm.$t("mdfeTranslate.MessageBody"),
                  "min-width": "200",
                  "show-overflow-tooltip": false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "pre",
                            {
                              staticStyle: {
                                "max-height": "400px",
                                overflow: "auto",
                              },
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _vm._v(
                                "              " +
                                  _vm._s(scope.row.msgBody) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "paramsStyle" }, [
                            _vm._v(_vm._s(scope.row.msgBody)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "failedReason",
                  label: _vm.$t("GlobalSetObj.ReasonForFailure"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("GlobalSetObj.CreationTime"),
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: _vm.$t("GlobalSetObj.UpdateTime"),
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.operate"),
                  fixed: "right",
                  width: "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:invoiceCenter:cte-rebuildCreate",
                                expression:
                                  "'btn:invoiceCenter:cte-rebuildCreate'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.rebuildCreate(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Rebuild")) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTable,
                  "size-change": _vm.getSizeTable,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("GlobalSetObj.Rebuild"),
            visible: _vm.showBulkExportWindow,
            width: "600px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBulkExportWindow = $event
            },
            close: _vm.closeBulkExport,
          },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "20px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.businessType,
                      callback: function ($$v) {
                        _vm.businessType = $$v
                      },
                      expression: "businessType",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: 0 } }, [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.expressDelivery"))
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: 1 } }, [
                      _vm._v(_vm._s(_vm.$t("collectionCenter.lanshou"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("orderCenterCont.DownloadTemplate")) + "："),
            ]),
            _c(
              "div",
              {
                ref: "download1",
                staticStyle: {
                  display: "inline-block",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.initDown()
                      },
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#00A551" } }, [
                      _vm._v("批量重新生成模板.xlsx"),
                    ]),
                    _c("span", {
                      staticClass: "el-icon-download",
                      staticStyle: { color: "#00A551", "margin-left": "20px" },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-upload",
                  {
                    ref: "demoUpload",
                    staticClass: "upload-demo",
                    attrs: {
                      "before-upload": _vm.beforeUpload,
                      "file-list": _vm.orderNumber,
                      "http-request": _vm.upLoad,
                      limit: 1,
                      "on-exceed": _vm.handleExceed,
                      "on-remove": _vm.handleRemove,
                      action: "",
                      drag: "",
                      multiple: "",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      staticStyle: { margin: "50px auto 20px" },
                    }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("orderImport.cldrUpload"))),
                    ]),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("orderCenterCont.OnlyExcelFilesCanBeUploaded")
                        )
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showBulkExportWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmBulkExport },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }